<div [class]="orientation">
  <mat-radio-group [color]="color" [(ngModel)]="displayNumberProfile" (ngModelChange)="updateDisplayNumberProfile()" [disabled]="!canEdit">
    <mat-radio-button [value]="1">
      {{ 'display_number.always_my_number' | translate }}
    </mat-radio-button>
    <mat-radio-button [value]="2">
      {{ 'display_number.working_hours_main_number' | translate }}
    </mat-radio-button>
    <mat-radio-button [value]="3">
      {{ 'display_number.always_main_number' | translate }}
    </mat-radio-button>
    <ng-container *ngIf="showExtendedDisplayNumberChoices">
      <mat-radio-button [value]="4">
        {{ 'display_number.always_business_number' | translate }}
      </mat-radio-button>
      <mat-radio-button [value]="5">
        {{ 'display_number.always_private_number' | translate }}
      </mat-radio-button>
      <mat-radio-button [value]="6">
        {{ 'display_number.working_hours_business_number' | translate }}
      </mat-radio-button>
    </ng-container>
  </mat-radio-group>
  <div class="number-selection">
    <ng-container *ngIf="displayNumberProfile === 2 || displayNumberProfile === 3">
      <gt-display-number-selector
        [login]="login"
        [oname]="oname"
        [canEdit]="canEdit"
        [fullNumber]="fullNumber"
        [placeholder]="placeholder"
      ></gt-display-number-selector>
    </ng-container>
  </div>
</div>
